import { history, useModel } from '@umijs/max';
import { Avatar, Tag, Button } from 'antd'
import { stringify } from 'querystring';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import './style.less'
import { useState, useRef, useEffect } from 'react';
const UserModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef<any>(null);
  const { initialState } = useModel('@@initialState');
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  // 显示内容div
  const showContent = () => {
    setIsVisible(true);
  };
   // 延迟隐藏内容div
  const hideContent = () => {
    timeoutRef!.current = setTimeout(() => {
      setIsVisible(false);
    }, 200); // 200ms延迟避免误触
  };
 
  // 取消隐藏（当鼠标进入内容div时）
  const cancelHide = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
  const icon = () => {
    if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return <ExclamationCircleOutlined />
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return <CheckCircleOutlined />
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return <ExclamationCircleOutlined />
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return <CheckCircleOutlined />
    }
    return <ExclamationCircleOutlined />
  }
  const color = () => {
    if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return 'warning'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return '#01BD27'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return 'warning'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return 'processing'
    }
    return 'warning'
  }
  const name = () => {
    if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return '个人认证中'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 1 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return '个人认证'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 1) {
      return '企业认证中'
    } else if (initialState?.UserDetailInfo?.personOrEnterprise === 2 && initialState.UserDetailInfo?.certificationStatus === 2) {
      return '企业认证'
    }
    return '未认证'
  }
  const logout = () => {
    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    localStorage.removeItem('token');
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/user/login' && !redirect) {
      history.replace({
        pathname: '/user/login',
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
  }
  return (
    <div style={{position: 'relative'}}>
      <div  style={{cursor: 'pointer'}} onMouseEnter={showContent} onMouseLeave={hideContent}>
        <Avatar style={{marginRight: '8px', backgroundColor: '#ECF3FF', color: '#1664FF'}}>{initialState?.currentUser?.customName?.substring(0, 1)}</Avatar><span className='name'>{initialState?.currentUser?.customName}</span>
      </div>
      {isVisible && (
        <div className='modal' onMouseEnter={cancelHide} onMouseLeave={hideContent}>
          <div className='modal_box'>
            <Avatar size={56} style={{marginRight: '8px', backgroundColor: '#ECF3FF', color: '#1664FF'}}>{initialState?.currentUser?.customName?.substring(0, 1)}</Avatar>
            <div className='modal_nav'>
              <div className='modal_name'>{initialState?.currentUser?.customName}</div>
              <div className='modal_id'>用户ID: {initialState?.currentUser?.id}</div>
              <div className='modal_nav_tag'>
                <Tag>{initialState?.currentUser?.customUserType === 1? '主账号': initialState?.currentUser?.customUserType === 2? '子账号' : '个人账号'}</Tag>
                <Tag 
                  icon={icon()}
                  color={color()}>
                  {name()}
                </Tag>
              </div>
            </div>
            <div className='modal_user_info' onClick={() => history.push('/account/setOpt')}>{`账号中心 >`}</div>
          </div>
          <Button className='cancel' onClick={logout}>退出登录</Button>
        </div>
      )}
    </div>
  )
}

export default UserModal